import React, { useState, useEffect, useRef } from "react";
import { useSearch } from "../../Contexts/SearchContext";
import LevelOneFilterDrawerAccordion from "./LevelOneFilterDrawerAccordion/LevelOneFilterDrawerAccordion";
import FilterDrawerButtons from "./FilterDrawerButtons/FilterDrawerButtons";
import SearchBar from "../SearchBar/SearchBar";
import "./FilterDrawer.scss";

const FilterDrawer = () => {
  const { state, dispatch } = useSearch();

  const {
    filterContainerIsVisible,
    filterDrawerIsOpen,
    searchBarHasFocus,
    filterJson,
    sortTypeApplied,
  } = state;

  const hideFilterContainer = () => {
    dispatch({ type: "UPDATE_FILTER_CONTAINER_IS_VISIBLE", payload: false });
  };

  const toggleFilterDrawer = () => {
    dispatch({
      type: "UPDATE_FILTER_DRAWER_IS_OPEN",
      payload: !filterDrawerIsOpen,
    });
  };

  //close drawer on esc press down
  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.code === "Escape") {
        hideFilterContainer();
      }
    };

    document.addEventListener("keydown", handleEscapeKey);
    return () => document.removeEventListener("keydown", handleEscapeKey);
  });

  // Close filter drawer if clicked outside the drawer
  useEffect(() => {
    const handleClickOutsideFilter = (event) => {
      if (
        filterContainerIsVisible &&
        !FilterDrawerRef.current.contains(event.target)
      ) {
        hideFilterContainer();
      }
    };

    document.addEventListener("click", handleClickOutsideFilter);
    return () =>
      document.removeEventListener("click", handleClickOutsideFilter);
  });

  let filterContainerIsVisibleClass = filterContainerIsVisible
    ? " cmp-site-search__filter-drawer-container--visible"
    : "";
  let filterDrawerIsOpenClass = filterDrawerIsOpen ? " open" : "";

  return (
    <>
      <div
        className={`cmp-site-search__search-and-filters-container${
          searchBarHasFocus ? " search-in-progress" : ""
        }${
          filterDrawerIsOpen ? " filter-drawer-open" : ""
        }`}
      >
        <div className="cmp-site-search__filter-drawer-heading">Filters</div>
        <div className="cmp-site-search__search-container filter-search-bar">
          <SearchBar/>
        </div>
        <div
          className={`cmp-site-search__filter-drawer-container${filterContainerIsVisibleClass}${
            searchBarHasFocus ? " hidden" : ""
          }`}
        >
          <div className="cmp-site-search__filter-dropdown-heading-container">
            <div
              className={`cmp-site-search__filter-dropdown-heading main-heading${filterDrawerIsOpenClass}`}
              onClick={toggleFilterDrawer}
            >
              Filter Results<span className="chevron"></span>
            </div>
          </div>
          <div
            className={`cmp-site-search__filter-drawer${filterDrawerIsOpenClass}`}
          >
            <ul>
              {filterJson &&
                filterJson.filterList?.map((dropdown, index) => (
                  <li>
                    {dropdown.type === "levelOneDropdown" && (
                      <LevelOneFilterDrawerAccordion
                        data={dropdown}
                        sortTypeApplied={sortTypeApplied}
                        class={"cmp-site-search__level-one-dropdown"}
                        index={index}
                      />
                    )}
                  </li>
                ))}
            </ul>

            <FilterDrawerButtons />
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterDrawer;
